export var createMuiSnackbarOverrides = function (_a) {
    var _b, _c;
    var typography = _a.typography, breakpoints = _a.breakpoints, tokens = _a.tokens;
    var top = tokens.size_layout_app_top + tokens.size_layout_app_bar_height + 24;
    return {
        defaultProps: {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
        },
        styleOverrides: {
            root: {
                maxWidth: typography.pxToRem(640),
            },
            anchorOriginTopRight: (_b = {},
                _b[breakpoints.up('sm')] = {
                    top: top,
                },
                _b),
            anchorOriginTopCenter: (_c = {},
                _c[breakpoints.up('sm')] = {
                    top: top,
                },
                _c),
        },
    };
};
